import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import { isAuth0Enabled } from "../../auth/auth0Config";

function LocalPrivateRoute({ children, allowedRoles, isAuthenticated = false }) {
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!isAuthenticated && !token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function Auth0PrivateRoute(props) {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return <LocalPrivateRoute {...props} isAuthenticated={isAuthenticated} />;
}

function PrivateRoute(props) {
  if (isAuth0Enabled) return <Auth0PrivateRoute {...props} />;

  return <LocalPrivateRoute {...props} />;
}

export default PrivateRoute;
